module.exports = __webpack_public_path__ + "static/btp_pipes_1-a33cc580163870a406263b558bea015a.png";